<template>
  <v-container class="mt-4">
    <v-row v-resize="onResize">
      <v-col cols="7">
        <h1
          class="mb-3"
          :class="{ 'text-h6': isMobile, 'text-h5': !isMobile}"
          v-html="$t('advertiser.title') + ' (' + agency.agencyName + ')'"
        ></h1>
      </v-col>
      <v-col cols="5" class="text-right">
        <v-col v-if="showDigestive">
          <v-btn color="light-blue darken-1 text-white" @click="routerToDigestive">
            {{ $t('commons.global.menu.digestive') }}
          </v-btn>
          <v-col v-if="isHiddenForRoleAgency" class="caption text-red-accent-4">{{ $t('commons.global.info.digestive') }}</v-col>
        </v-col>
      </v-col>
      <v-col cols="12" v-if="errorMessage">
        <v-alert :value="true" type="error" v-html="$t(errorMessage)"></v-alert>
      </v-col>
      <v-col cols="6" md="4">
        <v-select
          v-model="selectedDeliveryMonth"
          :items="deliveryMonths"
          item-title="label"
          item-value="value"
          :label="$t('commons.form.select.measureperiod.yearmonth-cpm')"
          class="select-digestives"
          @update:modelValue="previewAdvertiserList()"
          return-object
          variant="underlined"
        ></v-select>
      </v-col>
      <v-col cols="6" md="6">
        <v-text-field v-model="inputAdvertiserName" label="広告主名" @change="previewAdvertiserList()" variant="underlined"></v-text-field>
      </v-col>
    </v-row>
    <v-row justify-center>
      <v-col cols="12">
        <v-data-table
          :headers="advertiserListHeaders"
          :items="advertiserList"
          :hide-default-header="isMobile"
          hide-default-footer
          :sort-by="sortBy"
          :sortDesc="false"
          :loading="isSearching"
          :items-per-page="-1"
          :no-data-text="$t('commons.table.no.data.text')"
          class="elevation-3 advertiser-list"
          :class="{mobile: isMobile}"
        >
          <template v-slot:item="props">
            <tr v-if="!isMobile">
              <td class="text-left break-word-cell caption">
                <span class="link" @click="navigateToCampaign(props.item.agencyId, props.item.advertiserId)">{{ props.item.advertiserName }}</span>
              </td>
              <td class="text-center">
                <span @click="navigateToCampaignLanding(props.item.agencyId, props.item.advertiserId)">
                  <v-icon style="height: 16px">mdi-open-in-new</v-icon>
                </span>
              </td>
            </tr>
            <tr v-else>
              <td @click="navigateToCampaign(props.item.agencyId, props.item.advertiserId)">
                <v-row align="center">
                  <v-col cols="11">
                    <ul class="flex-content body-2">
                      <li
                        class="flex-item word-break"
                        :data-label="$t('advertiser.headers.advertiserName')"
                      >{{ props.item.advertiserName }}</li>
                    </ul>
                  </v-col>
                  <v-col cols="1">
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-col>
                </v-row>
              </td>
              <td @click="navigateToCampaignLanding(props.item.agencyId, props.item.advertiserId)">
                <v-row align="center">
                  <v-col cols="11">
                    <ul class="flex-content">
                      <li
                        class="flex-item word-break"
                        :data-label="$t('advertiser.headers.submissionConfirmationLink')"
                      ></li>
                    </ul>
                  </v-col>
                  <v-col cols="1">
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-col>
                </v-row>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'AdvertiserList',
  props: ['agencyId'],
  data: function () {
    return {
      sortBy: [{ key: 'advertiserName', order: 'asc'}],
      isSearching: false,
      selectedDeliveryMonth: {},
      deliveryMonths: [],
      inputAdvertiserName: '',
      advertiserListHeaders: [
        {
          title: this.$t('advertiser.headers.advertiserName'),
          align: 'left',
          key: 'advertiserName'
        },
        {
          title: this.$t('advertiser.headers.submissionConfirmationLink'),
          align: 'center',
          key: 'submissionConfirmationLink',
          width: '190',
          sortable: false
        }
      ],
      advertiserList: [],
      agency: {},
      showDigestive: false,
      isCpmMode: false,
      isHiddenForRoleAgency: true,
      privateCode: process.env.ProjectCode,
      isMobile: false,
      errorMessage: undefined
    }
  },
  methods: {
    ...mapActions('deliveryMonth', ['getMonthAllList', 'setSelectedDeliveryMonth']),
    ...mapActions('advertiser', ['getAdvertiserList']),
    ...mapActions('headerParam', ['setHeaderParamAgencyAdvertiser']),
    initialize: function () {
      // カレンダーの初期化とリストの初期表示
      this.getMonthAllList().then((result) => {
        this.deliveryMonths = result
        const params = 'deliveryMonth/selectedDeliveryMonth'
        // 当月を指定する（全てが存在するから配列２）
        var defaultDeliveryMonth = result[2]
        if (this.$route.query.yearMonth !== undefined) {
          for (var i in result) {
            if (this.$route.query.yearMonth === result[i].value) {
              defaultDeliveryMonth = result[i]
            }
          }
        } else if (this.$store.getters[params] !== undefined) {
          defaultDeliveryMonth = this.$store.getters[params]
        }
        this.selectedDeliveryMonth = defaultDeliveryMonth
        this.previewAdvertiserList()
      })
      this.setHeaderParamAgencyAdvertiser({ agencyId: this.agencyId, advertiserId: this.advertiserId })
    },
    previewAdvertiserList: function () {
      this.isSearching = true
      const jwtToken = this.$store.getters['auth/jwtToken']
      const deliveryMonth = this.selectedDeliveryMonth.value
      this.setSelectedDeliveryMonth(this.selectedDeliveryMonth)
      const agencyId = this.agencyId
      const advertiserName = this.inputAdvertiserName
      // URLにパラメータを付与
      this.$router.replace({
        query: { yearMonth: deliveryMonth }
      }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('Router replace error:', err);
        }
      });

      this.getAdvertiserList({
        privateCode: this.privateCode,
        agencyId: agencyId,
        deliveryMonth: deliveryMonth,
        advertiserName: advertiserName,
        jwtToken: jwtToken
      })
        .then((result) => {
          this.isSearching = false
          this.errorMessage = undefined
          if (!result) {
            // 表示するデータがない場合
            this.advertiserList = []
            this.agency = {}
            return
          }
          this.advertiserList = result.advertiserList
          this.agency = result.agency
          // 「請求情報ボタン」表示の判断をする
          this.isHiddenForRoleAgency = !this.agency.openDigestiveForAgencyUser
          this.showDigestive = this.isDigestiveVisible()
        })
        .catch((err) => {
          this.isSearching = false
          if (err instanceof ReferenceError) {
            this.errorMessage = err.message
          } else {
            // idToken が切れているのでセッションを切り、ログイン画面に遷移する
            this.$store.dispatch('auth/logout')
            this.$router.go({ path: this.$router.currentRoute.path, force: true })
          }
        })
    },
    onResize: function () {
      if (window.innerWidth < 960) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    isDigestiveVisible: function() {
      // Logicad 側からの「代理店ユーザへ開示する」の True/False
      const isOpenForRoleAgency = this.agency.openDigestiveForAgencyUser
      const isRoleSuper = this.$store.getters['auth/isRoleSuper']
      const isRoleAgency = this.$store.getters['auth/isRoleAgency']

      // CPM 画面の場合、ユーザのロールに関係なく表示しない
      if (this.isCpmMode) {
        return false
      }

      // 管理者ロールの場合、表示する
      if (isRoleSuper) {
        return true
      // 代理店ロール && Logicad 側から「代理店ユーザへ開示する」の場合、表示する
      } else if (isRoleAgency && isOpenForRoleAgency) {
        return true
      } else {
        return false
      }
    },
    navigateToCampaign: function (agencyId, advertiserId) {
      if (this.isCpmMode) {
        this.$router.push(`/campaignList/${agencyId}/${advertiserId}`)
      } else {
        this.$router.push(`/campaignPeriodList/${agencyId}/${advertiserId}`)
      }
    },
    navigateToCampaignLanding: function (agencyId, advertiserId) {
      this.$router.push(`/campaignLanding/counts/${agencyId}/${advertiserId}`)
    },
    routerToDigestive: function() {
      if (this.showDigestive) {
        var agencyId = this.agencyId
        var advertiserId = this.advertiserId === void 0 ? '0' : this.advertiserId
        this.$router.push('/digestive/' + agencyId + '/' + advertiserId)
      }
    }
  },
  beforeRouteUpdate: function (to, from, next) {
    next()
  },
  mounted: function () {
    if (this.privateCode === '111') {
      this.isCpmMode = true
    }
    this.initialize()
  }
}
</script>
<style scoped>
.advertiser-list .break-word-cell {
  max-width: 500px;
  word-wrap: break-word;
}
</style>
